import React from "react";
import { ColorPicker } from "@common/colorPicker";
import { SelectList } from "@common/selectList";
import { DefaultIcon } from "./icon";

import { Props } from "./types";
import styles from "./styles.scss";

function ColorPickerInput({ color, edit }: Props) {
  return (
    <SelectList rootClassName={styles.colorPickerInput}>
      {() => ({
        input: (
          <div className={styles.colorInput}>
            {!!color ? (
              <div
                className={styles.color}
                style={{ backgroundColor: color }}
              />
            ) : (
              <DefaultIcon className={styles.color} />
            )}
          </div>
        ),
        list: <ColorPicker color={color} pick={edit} />,
      })}
    </SelectList>
  );
}

export { ColorPickerInput };
